import request from '@/common/request'

class NCMService {
  getAll() {
    return request.get('/ncms')
  }

  getById(ncmId) {
    return request.get(`/ncms/${ncmId}`)
  }

  getClassificacoesByNCM(id) {
    return request.get(`/ncms/${id}/classificacoes`)
  }

  create(data) {
    return request.post('/ncms', data)
  }

  update(id, data) {
    return request.patch(`/ncms/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/ncms/${id}`)
  }

  getEstruturaByCodigo(codigo) {
    return request.get(`/ncms/estruturas/${codigo}`)
  }
}

export default new NCMService()
